import BuildingDirectoryApi from '../api/routes/BuildingDirectoryApi';
import TradeProbability from '../pages/TradeProbability/models/tradeProbability';
import TradeProbabilityInfo from '../pages/TradeProbability/models/tradeProbabilityInfo';

const TradeProbabilitiesKey = 'TradeProbabilities';
const CachingTimeInHours = 24;
const dummyTradeProbabilities: TradeProbabilityInfo[] = [
    new TradeProbabilityInfo({
        id: 'tp-dummy-1',
        lat: 1.2796,
        lon: 103.8519,
        p: 25000000,
        pn: 'Marina Bay Office',
        pa: '12 Marina View, Singapore',
        ap: 2
    }),
    new TradeProbabilityInfo({
        id: 'tp-dummy-2',
        lat: 35.6812,
        lon: 139.7671,
        p: 32000000,
        pn: 'Tokyo Midtown Retail',
        pa: '2-2-1 Yaesu, Tokyo',
        ap: 4
    }),
    new TradeProbabilityInfo({
        id: 'tp-dummy-3',
        lat: -33.8688,
        lon: 151.2093,
        p: 19000000,
        pn: 'Sydney Core Workspace',
        pa: '88 Pitt St, Sydney',
        ap: 1
    }),
    new TradeProbabilityInfo({
        id: 'tp-dummy-4',
        lat: 13.7563,
        lon: 100.5018,
        p: 14000000,
        pn: 'Bangkok Hospitality Hub',
        pa: '120 Charoen Krung Rd, Bangkok',
        ap: 6
    }),
];

const dummyTradeProbabilityDetails: Record<string, TradeProbability> = {
    'tp-dummy-1': {
        id: 'tp-dummy-1',
        portFolio: 'No',
        propertyNB: 1,
        lastSalesDate: '2022-11-01T00:00:00.000Z',
        propertyName: 'Marina Bay Office',
        address: '12 Marina View, Singapore',
        city: 'Singapore',
        country: 'Singapore',
        cbd: 'Downtown Core',
        mainType: 'Office',
        yearBuilt: 2018,
        yearRenuExp: 0,
        numberBldgs: 1,
        price: 25000000,
        dealBucket: '20M-30M',
        buyer: 'Institutional',
        crossBorder: 'No',
        buyerObjective: 'Investment',
        lat: 1.2796,
        lon: 103.8519,
        closePriceLocal: 25000000,
        localCurrencyCode: 'USD',
        transType: 'Sale',
        transSubType: 'Asset',
        partialInterestType: 'N/A',
        predictionClass: 'Medium',
        timeSinceLastSale: 2,
        allPredictions: 2,
        frequencyOfTrade: 3,
        avgHoldTimeCity: 5,
        cbbpcaht: 2,
        jointVenture: 0,
        ajvnjvhtc: 1,
        region: 'APAC'
    },
    'tp-dummy-2': {
        id: 'tp-dummy-2',
        portFolio: 'No',
        propertyNB: 1,
        lastSalesDate: '2021-05-18T00:00:00.000Z',
        propertyName: 'Tokyo Midtown Retail',
        address: '2-2-1 Yaesu, Tokyo',
        city: 'Tokyo',
        country: 'Japan',
        cbd: 'Tokyo Station',
        mainType: 'Retail',
        yearBuilt: 2019,
        yearRenuExp: 0,
        numberBldgs: 1,
        price: 32000000,
        dealBucket: '30M-40M',
        buyer: 'Private',
        crossBorder: 'Yes',
        buyerObjective: 'Renovation',
        lat: 35.6812,
        lon: 139.7671,
        closePriceLocal: 32000000,
        localCurrencyCode: 'USD',
        transType: 'Sale',
        transSubType: 'Asset',
        partialInterestType: 'N/A',
        predictionClass: 'High',
        timeSinceLastSale: 4,
        allPredictions: 4,
        frequencyOfTrade: 2,
        avgHoldTimeCity: 6,
        cbbpcaht: 3,
        jointVenture: 1,
        ajvnjvhtc: 2,
        region: 'APAC'
    },
    'tp-dummy-3': {
        id: 'tp-dummy-3',
        portFolio: 'Yes',
        propertyNB: 3,
        lastSalesDate: '2023-01-10T00:00:00.000Z',
        propertyName: 'Sydney Core Workspace',
        address: '88 Pitt St, Sydney',
        city: 'Sydney',
        country: 'Australia',
        cbd: 'Sydney CBD',
        mainType: 'Office',
        yearBuilt: 2012,
        yearRenuExp: 2020,
        numberBldgs: 1,
        price: 19000000,
        dealBucket: '10M-20M',
        buyer: 'Public',
        crossBorder: 'No',
        buyerObjective: 'Occupancy',
        lat: -33.8688,
        lon: 151.2093,
        closePriceLocal: 19000000,
        localCurrencyCode: 'USD',
        transType: 'Sale',
        transSubType: 'Portfolio',
        partialInterestType: 'N/A',
        predictionClass: 'Low',
        timeSinceLastSale: 1,
        allPredictions: 1,
        frequencyOfTrade: 4,
        avgHoldTimeCity: 4,
        cbbpcaht: 1,
        jointVenture: 0,
        ajvnjvhtc: 1,
        region: 'APAC'
    },
    'tp-dummy-4': {
        id: 'tp-dummy-4',
        portFolio: 'No',
        propertyNB: 1,
        lastSalesDate: '2020-09-07T00:00:00.000Z',
        propertyName: 'Bangkok Hospitality Hub',
        address: '120 Charoen Krung Rd, Bangkok',
        city: 'Bangkok',
        country: 'Thailand',
        cbd: 'Silom',
        mainType: 'Hotel',
        yearBuilt: 2015,
        yearRenuExp: 0,
        numberBldgs: 1,
        price: 14000000,
        dealBucket: '10M-20M',
        buyer: 'User/Other',
        crossBorder: 'Yes',
        buyerObjective: 'Redevelopment',
        lat: 13.7563,
        lon: 100.5018,
        closePriceLocal: 14000000,
        localCurrencyCode: 'USD',
        transType: 'Sale',
        transSubType: 'Asset',
        partialInterestType: 'N/A',
        predictionClass: 'Medium',
        timeSinceLastSale: 6,
        allPredictions: 6,
        frequencyOfTrade: 1,
        avgHoldTimeCity: 8,
        cbbpcaht: 4,
        jointVenture: 1,
        ajvnjvhtc: 2,
        region: 'APAC'
    },
};

const GetCachedTime = () => {
    const cachedTime = new Date(localStorage.getItem(`${TradeProbabilitiesKey}Time`)!);
    const msBetweenDates = Math.abs(cachedTime.getTime() - new Date().getTime());
    const hoursBetweenDates = msBetweenDates / (60 * 60 * 1000);

    return hoursBetweenDates;
}

const syncDataWithIndexDb = (region: string, data?: TradeProbabilityInfo[]): Promise<TradeProbabilityInfo[]> => {
    return new Promise<TradeProbabilityInfo[]>((resolve, reject) => {
        if (!data) {
            const hoursBetweenDates = GetCachedTime();
            if (hoursBetweenDates > CachingTimeInHours) {
                reject();
                return;
            }
        }

        const idb = window.indexedDB;

        // Open (or create) the database
        const open = idb.open('Virgate', 1);

        // Create the schema
        open.onupgradeneeded = function () {
            const db = open.result;
            const objectStoreExisted = db.objectStoreNames.contains(TradeProbabilitiesKey);

            if (!data && !objectStoreExisted) {
                reject();
            }

            db.createObjectStore(TradeProbabilitiesKey);
        };

        open.onsuccess = function () {
            // Start a new transaction
            const db = open.result;
            const tx = db.transaction(TradeProbabilitiesKey, 'readwrite');
            const store = tx.objectStore(TradeProbabilitiesKey);

            if (data) {
                // Add some data
                store.put(data, region);
                localStorage.setItem(`${TradeProbabilitiesKey}Time`, new Date().toLocaleString());
            } else {
                // Query the data
                const queriedData = store.get(region);

                queriedData.onsuccess = function () {
                    if (queriedData.result) {
                        resolve(queriedData.result);
                    } else {
                        reject();
                    }
                };
            }

            // Close the db when the transaction is done
            tx.oncomplete = function () {
                db.close();
            };
        }
    });
}

const fetchTradeProbabilities = async (region: string, lon?: number, lat?: number): Promise<TradeProbabilityInfo[]> => {
    try {
        const tradeProbabilities = await syncDataWithIndexDb(region);
        return tradeProbabilities.map(x => new TradeProbabilityInfo(x));
    } catch (_cacheError) {
        try {
            const response = await BuildingDirectoryApi.fetchTradeProbabilities(region, lon, lat);
            const tradeProbabilities = response.data;
            syncDataWithIndexDb(region, tradeProbabilities);
            return tradeProbabilities.map(x => new TradeProbabilityInfo(x));
        } catch (_apiError) {
            return dummyTradeProbabilities;
        }
    }
};

const fetchTradeProbability = async (id: string): Promise<TradeProbability> => {
    try {
        if (dummyTradeProbabilityDetails[id]) {
            return dummyTradeProbabilityDetails[id];
        }
        const response = await BuildingDirectoryApi.fetchTradeProbability(id);
        return response.data as any;
    } catch (e) {
        if (dummyTradeProbabilityDetails[id]) {
            return dummyTradeProbabilityDetails[id];
        }
        throw e;
    }
};

const TradeProbabilityService = {
    fetchTradeProbabilities,
    fetchTradeProbability,
};

export default TradeProbabilityService;
